import { createApi } from '@reduxjs/toolkit/query/react'
import { DELETE_REPORT, DELETE_RESOURCE, DIAGNOSIS_SERVERITY_LIST, FAVOURITE_REPORT, LIST_CLIENT_DETAILS_REPORTS, PARENT_REPORTS, RESTORE_RESOURCE } from "config/apiPaths"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const resourceApi = createApi({
    reducerPath: 'resourceApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/resource",
    }),
    endpoints: (builder) => ({
        // delete resource
        deleteResource: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${DELETE_RESOURCE}/${id}`
            }),
        }),

        // restore resource
        restoreResource: builder.mutation({
            query: (id) => ({
                method: "PUT",
                url: `${RESTORE_RESOURCE}/${id}`
            }),
        }),
        getResourcesList: builder.query({
            query: ({ search = "", id, attachment_name = "", page = 1, limit = 10, sort = { column: "id", direction: "DESC" } }) => ({
                method: "PATCH",
                url: `${PARENT_REPORTS}/${id}`,
                data: { search, page, limit, sort, attachment_name },
            }),
            transformResponse: (response) => {
                return response.data;
            },
        }),

        getClientDetailReportsList: builder.query({
            query: ({ search = "", page = 1, limit = 10, status = "", attachment_name, id, published = false, sort = { column: "id", direction: "DESC" } }) => {
                return ({
                    method: "PATCH",
                    url: `${LIST_CLIENT_DETAILS_REPORTS}/${id}`,
                    data: { search, page, limit, sort, attachment_name, published, status: status?.value }
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["reportsList"]
        }),

        favouriteReport: builder.mutation({
            query: ({ data, id }) => ({
                method: "PATCH",
                url: `${FAVOURITE_REPORT}/${id}`,
                data
            }),
            invalidatesTags: ["reportsList"]
        }),

        deleteReport: builder.mutation({
            query: ({ id, status }) => ({
                method: "PUT",
                url: `${DELETE_REPORT}/${id}/${status}`
            }),
            invalidatesTags: ["reportsList"]
        }),

        getDiagnosisList: builder.query({
            query: ({ search = "", page = 1, limit = 10, id, sort = { column: "id", direction: "DESC" } }) => {
                return ({
                    method: "PATCH",
                    url: `${DIAGNOSIS_SERVERITY_LIST}/${id}`,
                    data: { search, page, limit, sort }
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["reportsList"]
        }),
    }),


})

export const {
    useDeleteResourceMutation,
    useRestoreResourceMutation,
    useGetResourcesListQuery,
    useGetClientDetailReportsListQuery,
    useFavouriteReportMutation,
    useGetDiagnosisListQuery,
    useDeleteReportMutation
} = resourceApi;